import axios from 'axios';

const api_key = btoa(process.env.VUE_APP_COMPANIES_HOUSE_API_KEY);
const api = axios.create({
  baseURL: 'https://api.companieshouse.gov.uk',
  headers: { 'Content-Type': 'application/json', Authorization: `Basic ${api_key}` }
});

export default {
  searchCompanies(q, items_per_page, start_index) {
    return new Promise((resolve, reject) => {
      api
        .get('search/companies', {
          params: {
            q,
            items_per_page,
            start_index
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.toJSON()));
    });
  },

  getSicCodes(q) {
    return new Promise((resolve, reject) => {
      api
        .get('company/'+ q)
        .then(response => resolve(response.data.sic_codes))
        .catch(error => reject(error.toJSON()));
    });
  },
};
